import { PROYECT, api_put, api_delete, api_get, api_post } from "services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { printersTypes } from "redux/reducers/printers/printersTypes";
import { loginTypes } from "redux/reducers/login/loginTypes";

const {
  GET_PRINTERS,
  NEW_PRINTER,
  EDIT_PRINTER,
  DELETE_PRINTER,

  ADD_PRINT_QUEUE,
  DELETE_PRINT_QUEUE,
  PRINTING_LOADING_START,
  PRINTING_LOADING_STOP,
  RESTORE_PRINT
} = printersTypes
const {UPDATE_LOGIN_INFO} = loginTypes
const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}/printers`

export const getPrinters = () => {
  return async dispatch => {
    dispatch(startRequestComp('loadingPrinters'))
    try {
      const data = await api_get(mainUrl)
      await dispatch({ type: GET_PRINTERS, payload: data })
      await dispatch(stopRequestComp('loadingPrinters'))
    } catch (error) {
      dispatch(setSnackbar(error))
      dispatch(stopRequestComp('loadingPrinters'))
    }
  }
}

export const registerNewPrinter = ( form ) => {
  return async dispatch => {
    dispatch(startRequestComp('loadingFormPrinter'))
    await api_post(mainUrl, form).then(response => {
      dispatch({
        type: NEW_PRINTER,
        payload: response
      })
      dispatch(setSnackbar(`Nueva impresora registrada`, 'success'))
      dispatch(stopRequestComp('loadingFormPrinter'))
      
    }).catch(err => {
      dispatch(setSnackbar(err))
      dispatch(stopRequestComp('loadingFormPrinter'))
    })
  }
}

export const editPrinter = ( id, form ) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/printers/${id}`;
  return async dispatch => {
    dispatch(startRequestComp('loadingFormPrinter'))
    await api_put(url, form).then(response => {
      dispatch({
        type: EDIT_PRINTER,
        payload: {...response, id}
      })
      id === response.id && 
        dispatch({
          type: UPDATE_LOGIN_INFO,
          payload: response.config
        })
      dispatch(setSnackbar(`Impresora editada`, 'success'))
      dispatch(stopRequestComp('loadingFormPrinter'))
    }).catch(err => {
      dispatch(setSnackbar(err))
      dispatch(stopRequestComp('loadingFormPrinter'))
    })
  }
}

export const deletePrinter = ( id ) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/printers/${id}`;
  return async dispatch => {
    await api_delete(url).then(() => {
      dispatch({
        type: DELETE_PRINTER,
        payload: id
      })
      dispatch(setSnackbar(`Impresora eliminada`, 'success'))
      
    }).catch(err => {
      dispatch(setSnackbar(err))
      dispatch(stopRequestComp('loginLoading'))
    })
  }
}

export const addPrintQueue = (form) => {
  return  {
    type: ADD_PRINT_QUEUE,
    payload: form
  }
}

export const deletePrintQueue = (id) => {
  return {
    type: DELETE_PRINT_QUEUE,
    payload: id
  }
}

export const startPrint = (id) => {
  return {
    type: PRINTING_LOADING_START,
    payload: id
  }
}
export const stopPrint = (id, error='') => {
  return {
    type: PRINTING_LOADING_STOP,
    payload: {id, error}
  }
}

export const restorePrint = () => {
  return {type: RESTORE_PRINT}
}